import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimesCircle, faShare, faExternalLinkAlt, faPencilAlt} from "@fortawesome/free-solid-svg-icons";
import { Formik } from "formik";
import { RestAPI } from "@aws-amplify/api-rest";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { CONTRATO_MENSUAL, CONTRATO_TRIMESTAL, CONTRATO_SEMESTRAL, CONTRATO_ANUAL, SERVICE_DROPCONTROL_FREE, SERVICE_DROPCONTROL_DROPCONTROL, SERVICE_DROPCONTROL_LITE, SERVICE_DROPCONTROL_PREMIUM } from "../../utils/BillingUtils";

import { Dropdown } from "primereact/dropdown";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

import LoadingDialog from "../Utils/LoadingDialog";
import SelfHelp from "../Utils/SelfHelp";
import withName from "../../hoc/withName";
import DatosFact from "../BillingPolicyAndTerms/DatosFact";
import EditNClientDialog from "./EditNClientDialog";
import ButtonPrime from "../PrimeComponents/ButtonPrime";
import CalendarPrime from "../PrimeComponents/CalendarPrime";

const BillingParams = ({dataSource}) => {

    const { t, i18n } = useTranslation();
    const today = new Date();
    const navigate = useNavigate();
    const [onEdit, setOnEdit] = useState(false);
    const [onEditFact, setOnEditFact] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [integrators, setIntegrators] = useState([]);
    const [fullIntegrators, setFullIntegrators] = useState(null);
    const [isOnConfigured, setIsOnConfigured] = useState(true);
    const [originalValues, setOriginalValues] = useState(null);
    const [billingInfoFarm, setBillingInfoFarm] = useState(null);
    const [countries, setCountries] = useState(null);
    const [showMiniWizzard, setShowMiniWizzard] = useState(false);
    const [loadingClients, setLoadingClients] = useState(false);
    const [clients, setClients] = useState(null);
    const [newDatosFact,setNewDatosFact] = useState(null);
    const [hubs, setHubs] = useState([]);
    const [pricesLists, setPricesLists] = useState([]);
    const [newDatosFactList, setNewDatosFactList] = useState(null);
    const [validate, setValidate] = useState(false);
    const serviceLevels = [
        {"label":t("billing.serviceLevels.0"), "id":SERVICE_DROPCONTROL_FREE},
        {"label":t("billing.serviceLevels.1"), "id":SERVICE_DROPCONTROL_LITE},
        {"label":t("billing.serviceLevels.2"), "id":SERVICE_DROPCONTROL_DROPCONTROL},
        {"label":t("billing.serviceLevels.3"), "id":SERVICE_DROPCONTROL_PREMIUM},
    ];
    const billingPeriods = [
        {"label":t("billing.policyPage.periods."+CONTRATO_MENSUAL), "id":CONTRATO_MENSUAL},
        {"label":t("billing.policyPage.periods."+CONTRATO_TRIMESTAL), "id":CONTRATO_TRIMESTAL},
        {"label":t("billing.policyPage.periods."+CONTRATO_SEMESTRAL), "id":CONTRATO_SEMESTRAL},
        {"label":t("billing.policyPage.periods."+CONTRATO_ANUAL), "id":CONTRATO_ANUAL}];
    const monthString = t("forms.graphMeses").split("-");
    const billingMonths = {
        [CONTRATO_ANUAL]:[
            {"label":monthString[0], "id":1},
            {"label":monthString[1], "id":2},
            {"label":monthString[2], "id":3},
            {"label":monthString[3], "id":4},
            {"label":monthString[4], "id":5},
            {"label":monthString[5], "id":6},
            {"label":monthString[6], "id":7},
            {"label":monthString[7], "id":8},
            {"label":monthString[8], "id":9},
            {"label":monthString[9], "id":10},
            {"label":monthString[10], "id":11},
            {"label":monthString[11], "id":12}],
        [CONTRATO_TRIMESTAL]:[
            {"label":`${monthString[0]}-${monthString[3]}-${monthString[6]}-${monthString[9]}`, "id":1},
            {"label":`${monthString[1]}-${monthString[4]}-${monthString[7]}-${monthString[10]}`, "id":2},
            {"label":`${monthString[2]}-${monthString[5]}-${monthString[8]}-${monthString[11]}`, "id":3}],
        [CONTRATO_SEMESTRAL]:[
            {"label":`${monthString[0]}-${monthString[6]}`, "id":1},
            {"label":`${monthString[1]}-${monthString[7]}`, "id":2},
            {"label":`${monthString[2]}-${monthString[8]}`, "id":3},
            {"label":`${monthString[3]}-${monthString[9]}`, "id":4},
            {"label":`${monthString[4]}-${monthString[10]}`, "id":5},
            {"label":`${monthString[5]}-${monthString[11]}`, "id":6}]
    };
    const formikRef = useRef(null);
    const formikRefDatosFact = useRef(null);
    const selfHelpDescarga = [{
        tab: 1, header: { text: t("selfHelp.instructions") }, params:[]
    }];

    useEffect(() => {
        if(formikRef.current && validate){
            formikRef.current.validateForm();
            setValidate(false);
        }
    }, [validate]);
    useEffect(() => {
        if(integrators?.[0]?.integrators?.[0]){
            integrators[0].integrators[0].nombre = t("billing.noIntegrator");
            setIntegrators(integrators);
        }
    }, [t]);
    useEffect(() => {
        if(dataSource?.campo_id){
            RestAPI.get("apiAdminDropControl","/billing/agreements",
                {queryStringParameters: {"farmId":dataSource.campo_id}}).then(async (response) => {
                const farmInfo = response?.[0]?.result?.farmInfo?.[0];
                if(!farmInfo?.n_cliente_id){
                    farmInfo.n_cliente_id = -1;
                }
                setBillingInfoFarm(farmInfo);
                setCountries(response?.[0]?.result?.countries);
                setIsOnConfigured(farmInfo?.estado_billing==="CONFIGURED");
                formikRef.current && formikRef.current.setFieldValue("tipo_cobro",farmInfo?.periodo);
                formikRef.current && formikRef.current.setFieldValue("mes_facturacion",farmInfo?.mes_facturacion);
                formikRef.current && formikRef.current.setFieldValue("status",farmInfo?.estado_billing);
                formikRef.current && formikRef.current.setFieldValue("n_cliente_id",farmInfo?.n_cliente_id);
                formikRef.current && formikRef.current.setFieldValue("servicio_id",farmInfo?.ser_campo?.[0]?.config?.SERVICE);
                formikRef.current && formikRef.current.setFieldValue("integrador_id",farmInfo?.integrador_id??0);
                if(farmInfo?.fecha_fin_piloto)  formikRef.current && formikRef.current.setFieldValue("fecha_fin_piloto",new Date(farmInfo?.fecha_fin_piloto));
                if(farmInfo?.timeout_estado_billing) formikRef.current && formikRef.current.setFieldValue("timeout_estado_billing",new Date(farmInfo?.timeout_estado_billing));
                if(farmInfo?.fecha_aceptacion) formikRef.current && formikRef.current.setFieldValue("acceptance_date",new Date(farmInfo?.fecha_aceptacion));
                if(farmInfo?.usuario_aceptacion?.nombre){
                    const acepted_by = `${farmInfo?.usuario_aceptacion?.nombre} ${farmInfo?.usuario_aceptacion?.apellido_paterno} ${farmInfo?.usuario_aceptacion?.apellido_materno}`;
                    formikRef.current && formikRef.current.setFieldValue("accepted_by",acepted_by);
                }
                formikRef.current && formikRef.current.setFieldValue("hub",farmInfo?.hub?.nombre);
                formikRef.current && formikRef.current.setFieldValue("list",farmInfo?.lista?.nombre);

                RestAPI.get("apiAdminDropControl","/billing/billingparams",{}).then(async (response) => {
                    const dealers = response?.[0]?.result?.integradores??[];
                    const noIntegrator = {"nombre":t("billing.noIntegrator"), "integrador_id":0};
                    const integratorsFull = [noIntegrator].concat(dealers);
                    setFullIntegrators(integratorsFull);
                    const dealer = integratorsFull?.find(m => m.integrador_id === farmInfo?.integrador_id??0);
                    formikRef.current && formikRef.current.setFieldValue("tag_id",dealer?.tag_id);
                    dealers?.sort(function(a, b) {
                        const nameA = a.nombre.toUpperCase();
                        const nameB = b.nombre.toUpperCase();
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        return 0;
                    });
                    const groupedIntegrators = [
                        {
                            label:t("billing.integratorOwn"),
                            integrators:[]
                        },
                        {
                            label:t("billing.integratorAll"),
                            integrators:[]
                        }
                    ];
                    const ids = farmInfo?.integrators_list?.map(i => i.integrador_id);
                    const ownIntegrators = dealers?.filter(i => ids.includes(i.integrador_id));
                    const allIntegrators = dealers?.filter(i => !ids.includes(i.integrador_id));
                    groupedIntegrators[0].integrators =[noIntegrator].concat(ownIntegrators);
                    groupedIntegrators[1].integrators =allIntegrators;
                    setIntegrators(groupedIntegrators??[]);
                    setIsLoading(false);
                });
            })
                .catch((error) => {
                    console.log(error);
                    setIsLoading(false);
                });
        }
    },[dataSource]);

    const reload = () => {
        setInterval(() => {
            window.location.reload();
        }, 5000);
    };
    const getClientData = async () => {
        if(clients == null){
            setLoadingClients(true);
            RestAPI.get("apiAdminDropControl","/billing/clients").then(async (responseClients) => {
                setClients(responseClients);
                RestAPI.get("apiAdminDropControl","/billing/clientparams",
                    {queryStringParameters: {"clientId":billingInfoFarm?.n_cliente_id}}).then(async (responseParams) => {
                    setHubs(responseParams?.[0]?.result?.hubs);
                    setPricesLists(responseParams?.[0]?.result?.lists);
                    setLoadingClients(false);
                    setOnEditFact(true);
                    setShowMiniWizzard(true);
                });
            })
                .catch((error) => {
                    console.log(error);
                    setLoadingClients(false);
                });
        }else{
            setShowMiniWizzard(true);
        }
    };
    const accept = () => {
        const prevDealer = fullIntegrators?.find(m => m.integrador_id === billingInfoFarm?.integrador_id);
        formikRef.current && formikRef.current.setFieldValue("unLinkIntegrator",{"tag_id":prevDealer?.tag_id, "integrator_id":prevDealer?.integrador_id});
    };

    const reject = () => {
        formikRef.current && formikRef.current.setFieldValue("unLinkIntegrator",null);
    };
    const unlinkIntegrator = (dealer) => {
        confirmDialog({
            message: t("billing.dialogUnlinkDealer.msg",{dealer:dealer?.nombre}),
            header: t("billing.dialogUnlinkDealer.header"),
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            acceptLabel:t("general.answerYes"),
            rejectLabel:t("general.answerNo"),
            accept,
            reject
        });
    };
    return (
        <>{isLoading?
            <div className='row-container'>
                <LoadingDialog />
            </div>
            :null}
        <div className="row-container">
            <Formik innerRef={formikRef}
                initialValues={{
                }}
                validate={(data) => {
                    const errors = {};
                    return errors;
                }}
                onSubmit={async (formData) => {
                    setIsLoading(true);
                    formData.campo_id = dataSource?.campo_id;
                    await RestAPI.put("apiAdminDropControl", "/billing/billingparams", {body: {...formData, "type":"update"}}).then(async (response) => {
                        formikRef.current && formikRef.current.setFieldValue("tipo_cobro",response?.farm?.[0].tipo_cobro);
                        if(response?.farm?.[0]?.fecha_fin_piloto) formikRef.current && formikRef.current.setFieldValue("fecha_fin_piloto",new Date(response?.farm?.[0]?.fecha_fin_piloto));
                        if(response?.farm?.[0]?.timeout_estado_billing) formikRef.current && formikRef.current.setFieldValue("timeout_estado_billing",new Date(response?.farm?.[0]?.timeout_estado_billing));
                        formikRef.current && formikRef.current.setFieldValue("mes_facturacion",response?.farm?.[0].mes_facturacion);
                        formikRef.current && formikRef.current.setFieldValue("servicio_id",response?.ser_campo?.[0].config.SERVICE);
                        formikRef.current && formikRef.current.setFieldValue("tag_id",response?.tagTrue?.[0].tag_id);
                        const dealer = fullIntegrators?.find(m => m.tag_id === response?.tagTrue?.[0]?.tag_id);
                        billingInfoFarm.integrador_id = dealer?.integrador_id;
                        billingInfoFarm.ser_campo = response?.ser_campo;
                        formikRef.current && formikRef.current.setFieldValue("integrador_id",dealer?.integrador_id);
                        formikRef.current && formikRef.current.setFieldValue("unlinkIntegrator",null);
                        const indexNew = integrators?.[1]?.integrators?.findIndex(i => i.tag_id === response?.tagTrue?.[0]?.tag_id);
                        if(indexNew >=0){
                            const newOwnDealer = integrators?.[1]?.integrators?.splice(indexNew, 1)[0];
                            integrators?.[0]?.integrators?.push(newOwnDealer);
                        }
                        if(response?.deletedTag){
                            const indexDeleted = integrators?.[0]?.integrators?.findIndex(i => i.tag_id === response?.deletedTag?.[0]?.tag_id);
                            if(indexDeleted >=0){
                                const dealerAll = integrators?.[0]?.integrators?.splice(indexDeleted, 1)[0];
                                integrators?.[1]?.integrators?.push(dealerAll);
                            }
                        }
                        setOnEdit(false);
                        setIsLoading(false);
                        toast.success(t("billing.billingparamsSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                    })
                        .catch((error) => {
                            setIsLoading(false);
                            if(error?.response?.data === "MISSING_FACT_DATA"){
                                toast.error(t("billing.errorMissingData"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                            }
                            else if(error?.response?.data === "MISSING_VAT"){
                                toast.error(t("billing.errorMissingVat"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                            }else if(error?.response?.data === "YA_FACTURADO_PILOTO_DIFF"){
                                toast.error(t("billing.errorYaFacturado"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                            }
                            console.log(error);
                            toast.error(t("billing.billingparamsError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                        });
                }}
            >
                {({handleSubmit, values, setFieldValue, handleChange, errors}) => (
                    <>
                        <ConfirmDialog />
                        <div className='row'>
                            {loadingClients? <LoadingDialog /> :null}
                            {
                                billingInfoFarm?
                                    <EditNClientDialog
                                        setIsLoading={setIsLoading}
                                        showMiniWizzard={showMiniWizzard} setOnEdit={setOnEdit} setShowMiniWizzard={setShowMiniWizzard} setBillingInfoFarm={setBillingInfoFarm}
                                        farmInfo={billingInfoFarm} countries={countries} clients={clients} setLoading={setLoadingClients} originalValues={originalValues} formikRefDatosFact={formikRefDatosFact}
                                        hubs={hubs} pricesLists={pricesLists} setLoadingClients={setLoadingClients} formikRef={formikRef} setOriginalValues={setOriginalValues}
                                        setNewDatosFact={setNewDatosFact} setOnEditFact={setOnEditFact} newDatosFactList={newDatosFactList} setNewDatosFactList={setNewDatosFactList}
                                    />
                                    :null
                            }
                            <div className="col-xl-12 col-lg-12 col-sm-12">
                                <div id="cardRaw" className="card">
                                    <div className="card-body">
                                        <div className='row'>
                                            <div className='col col-sm-2 col-md-3 col-lg-3'>
                                                {false && selfHelpDescarga &&
                                                    <SelfHelp t={t} lng={i18n.language} params={selfHelpDescarga} fertiTable />}
                                            </div>
                                            <div className='col col-sm-10 col-md-8 col-lg-6 text-center'>
                                                <h5 className="card-title"><span>{t("billing.billingparams")}</span></h5>
                                            </div>
                                            <div className='col col-sm-3 col-md-3 col-lg-3 d-flex justify-content-end align-items-right align-items-center'>
                                                {
                                                    !onEdit?
                                                        <>
                                                            {
                                                                isOnConfigured?
                                                                    <ButtonPrime link  raised={false} tooltip={t("billing.nextState")} tooltipOptions={{ className:"tooltip-prime", position:"bottom"}} >
                                                                        <FontAwesomeIcon id="nextStatusIcon" name="nextStatusIcon" className='btnEdit pointer 2x' size="lg" style={{ color: "blue"}}
                                                                            icon={faShare} onClick={async ()=> {
                                                                                if(!billingInfoFarm?.ser_campo?.[0]?.config?.SERVICE){
                                                                                    toast.error(t("billing.noConfigured"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                                                                }else{
                                                                                    setIsLoading(true);
                                                                                    await RestAPI.put("apiAdminDropControl", "/billing/billingparams", {body: {"farmId":dataSource?.campo_id, "type":"status"}}).then(async (response) => {
                                                                                        setIsLoading(false);
                                                                                        formikRef.current && formikRef.current.setFieldValue("status","READY");
                                                                                        toast.success(t("billing.billingparamsSuccessNext"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                                                                        reload();
                                                                                    })
                                                                                        .catch((error) => {
                                                                                            setIsLoading(false);
                                                                                            if(error?.response?.data === "NOT_SERVICES"){
                                                                                                toast.error(t("billing.noConfigured"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                                                                            }else if(error?.response?.data?.startsWith("FARM_")){
                                                                                                toast.error(t("billing.errorNotConfigured"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                                                                            }else if(error?.response?.data === "ZERO_ADMINS" || error?.response?.data === "ZERO_USERS"){
                                                                                                toast.error(t("billing.errorZeroAdmins"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                                                                            }else{
                                                                                                toast.error(t("billing.billingparamsErrorNext"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                                                                            }
                                                                                        });
                                                                                }
                                                                            }}
                                                                        >
                                                                            {t("billing.nextState")}
                                                                        </FontAwesomeIcon>
                                                                    </ButtonPrime>
                                                                    :null
                                                            }
                                                            <FontAwesomeIcon
                                                                icon={faPencilAlt}
                                                                style={{ color: "grey", fontSize:"1.65rem", marginRight:"15px", cursor:"pointer" }}
                                                                onClick={(event) => {
                                                                    event.preventDefault();
                                                                    setOriginalValues({...formikRef?.current?.values});
                                                                    setOnEdit(true);
                                                                }}
                                                            >{t("forms.edit")}</FontAwesomeIcon>
                                                        </>
                                                        :
                                                        <>
                                                            <ButtonPrime t={t} template="formSave" onClick={(e) => {
                                                                setFieldValue("origin","params");
                                                                handleSubmit(e);
                                                            }} tooltip={t("forms.save")} tooltipOptions={{ className:"tooltip-prime", position:"bottom"}}
                                                            />
                                                            <ButtonPrime t={t} template="formCancel"
                                                                tooltip={t("forms.cancel")} tooltipOptions={{ className:"tooltip-prime", position:"bottom"}}
                                                                onClick={() => {
                                                                    setOnEdit(false);
                                                                    formikRef.current && formikRef.current.setFieldValue("servicio_id",originalValues?.servicio_id);
                                                                    formikRef.current && formikRef.current.setFieldValue("tipo_cobro",originalValues?.tipo_cobro);
                                                                    formikRef.current && formikRef.current.setFieldValue("mes_facturacion",originalValues?.mes_facturacion);
                                                                    formikRef.current && formikRef.current.setFieldValue("fecha_fin_piloto",originalValues?.fecha_fin_piloto);
                                                                    formikRef.current && formikRef.current.setFieldValue("timeout_estado_billing",originalValues?.timeout_estado_billing);
                                                                    formikRef.current && formikRef.current.setFieldValue("n_cliente_id",originalValues?.n_cliente_id);
                                                                    formikRef.current && formikRef.current.setFieldValue("mes_facturacion",originalValues?.mes_facturacion);
                                                                    formikRef.current && formikRef.current.setFieldValue("integrador_id",originalValues?.integrador_id);
                                                                    formikRef.current && formikRef.current.setFieldValue("datos_fact",originalValues?.datos_fact);
                                                                }}
                                                            />
                                                        </>
                                                }
                                            </div>
                                        </div>
                                        <div className='linea-titulo' />

                                        <div className="row">
                                            <div className="row linea-formulario col-12 text-center">
                                                <div className="col-8 col-md-4 text-sm-left mtem-05">
                                                    <label className="boldie">{t("billing.nCliente")}</label>
                                                </div>
                                                <div className="col-xl-3 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                                    <label>{values?.n_cliente_id>0?values?.n_cliente_id:""}</label>
                                                </div>
                                                {
                                                    onEdit?
                                                        <div className="col-xl-2 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                                            <ButtonPrime label={t("forms.change")} onClick={() => getClientData()} raised small />
                                                        </div>
                                                        :null
                                                }
                                                <div className="col-xl-2 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                                    <FontAwesomeIcon id="nextStatusIcon" name="nextStatusIcon" className='btnEdit pointer ' size="lg" style={{ color: "blue", marginRight :"15px" }}
                                                        icon={faExternalLinkAlt} onClick={()=> {if(values?.n_cliente_id && values?.n_cliente_id>0) navigate({ pathname: `/billing/clientparams/${values?.n_cliente_id}` });}}
                                                    >
                                                        {t("billing.nextState")}
                                                    </FontAwesomeIcon>
                                                </div>
                                            </div>
                                            <div className="row linea-formulario col-12 text-center">
                                                <div className="col-8 col-md-4 text-sm-left mtem-05">
                                                    <label className="boldie">{t("billing.serviceLevel")}</label>
                                                </div>
                                                <div className="col-8 col-md-8 col-lg-6 text-sm-left mtem-05">
                                                    {
                                                        !onEdit?
                                                            <label>{serviceLevels.find(m => m.id === values?.servicio_id)?.label}</label>
                                                            :
                                                            <Dropdown
                                                                value={values?.servicio_id}
                                                                onChange={handleChange}
                                                                options={serviceLevels} optionLabel="label" optionValue="id"
                                                                className="flex lgInputCstm w-100 p-0-ddpr" placeholder={t("billing.serviceLevel")}
                                                                inputId="servicio_id" name="servicio_id"
                                                            />
                                                    }
                                                </div>
                                            </div>
                                            <div className="row linea-formulario col-12 text-center">
                                                <div className="col-8 col-md-4 text-sm-left mtem-05">
                                                    <label className="boldie">{t("billing.endPilot")}</label>
                                                </div>
                                                <div className="col-8 col-md-8 col-lg-6 text-sm-left mtem-05">
                                                    {
                                                        billingInfoFarm?.ya_facturado?
                                                            <label>{values?.fecha_fin_piloto?values?.fecha_fin_piloto?.toLocaleDateString():t("billing.noPilotDefined")}</label>
                                                            :(!onEdit?
                                                                <label>{values?.fecha_fin_piloto?values?.fecha_fin_piloto?.toLocaleDateString():t("billing.noPilotDefined")}</label>:
                                                                <CalendarPrime
                                                                    t={t} style={{width:"100%"}}
                                                                    minDate={today} locale={i18n.language==="es"?"es":"en"} value={values?.fecha_fin_piloto}
                                                                    onChange={handleChange} dateFormat="dd/mm/yy"
                                                                    name="fecha_fin_piloto" inputId="fecha_fin_piloto"
                                                                />)
                                                    }
                                                </div>
                                            </div>
                                            <div className="row linea-formulario col-12 text-center">
                                                <div className="col-8 col-md-4 text-sm-left mtem-05">
                                                    <label className="boldie">{t("billing.policyPage.billingPeriod")}</label>
                                                </div>
                                                <div className="col-8 col-md-8 col-lg-6 text-sm-left mtem-05">
                                                    {
                                                        !onEdit?
                                                            <label>{billingPeriods.find(m => m.id === values?.tipo_cobro)?.label}</label>
                                                            :
                                                            <Dropdown
                                                                value={values?.tipo_cobro}
                                                                onChange={handleChange}
                                                                options={billingPeriods} optionLabel="label" optionValue="id"
                                                                className="flex lgInputCstm w-100 p-0-ddpr" placeholder={t("billing.policyPage.period")}
                                                                inputId="tipo_cobro" name="tipo_cobro"
                                                            />
                                                    }
                                                </div>
                                            </div>
                                            {
                                                values?.tipo_cobro!==CONTRATO_MENSUAL?
                                                    <div className="row linea-formulario col-12 text-center">
                                                        <div className="col-8 col-md-4 text-sm-left mtem-05">
                                                            <label className="boldie">{t("billing.billingMonth"+(values?.tipo_cobro===CONTRATO_ANUAL?"":"s"))}</label>
                                                        </div>
                                                        <div className="col-8 col-md-8 col-lg-6 text-sm-left mtem-05">
                                                            {
                                                                !onEdit?
                                                                    <label>{billingMonths?.[values?.tipo_cobro]?.find(m => m.id === values?.mes_facturacion)?.label}</label>
                                                                    :
                                                                    <Dropdown
                                                                        value={values?.mes_facturacion}
                                                                        onChange={handleChange}
                                                                        options={billingMonths?.[values?.tipo_cobro]} optionLabel="label" optionValue="id"
                                                                        className="flex lgInputCstm w-100 p-0-ddpr billingParams" placeholder={t("billing.billingMonth")}
                                                                        inputId="mes_facturacion" name="mes_facturacion"
                                                                    />
                                                            }
                                                        </div>
                                                    </div>
                                                    :null
                                            }
                                            <div className="row linea-formulario col-12 text-center">
                                                <div className="col-8 col-md-4 text-sm-left mtem-05">
                                                    <label className="boldie">{t("billing.status")}</label>
                                                </div>
                                                <div className="col-8 col-md-8 col-lg-6 text-sm-left mtem-05">
                                                    <label>{values?.status}</label>
                                                </div>
                                            </div>
                                            {
                                                values?.status==="DEPLOYED"?
                                                    null
                                                    :
                                                    <div className="row linea-formulario col-12 text-center">
                                                        <div className="col-8 col-md-4 text-sm-left mtem-05">
                                                            <label className="boldie">{t("billing.timeoutDate")}</label>
                                                        </div>
                                                        <div className="col-8 col-md-8 col-lg-6 text-sm-left mtem-05">
                                                            {
                                                                !onEdit?
                                                                    <label>{values?.timeout_estado_billing?.toLocaleDateString()}</label>
                                                                    :
                                                                    <CalendarPrime
                                                                        t={t} style={{width:"100%"}}
                                                                        minDate={today} locale={i18n.language==="es"?"es":"en"} value={values?.timeout_estado_billing}
                                                                        onChange={handleChange} dateFormat="dd/mm/yy"
                                                                        name="timeout_estado_billing" inputId="timeout_estado_billing"
                                                                    />
                                                            }
                                                        </div>
                                                    </div>
                                            }
                                            {
                                                values?.status==="DEPLOYED" && values?.acceptance_date?
                                                    <>
                                                        <div className="row linea-formulario col-12 text-center">
                                                            <div className="col-8 col-md-4 text-sm-left mtem-05">
                                                                <label className="boldie">{t("billing.acceptanceDate")}</label>
                                                            </div>
                                                            <div className="col-8 col-md-8 col-lg-6 text-sm-left mtem-05">
                                                                <label>{values?.acceptance_date?.toLocaleDateString()}</label>
                                                            </div>
                                                        </div>
                                                        {
                                                            values?.accepted_by?
                                                                <div className="row linea-formulario col-12 text-center">
                                                                    <div className="col-8 col-md-4 text-sm-left mtem-05">
                                                                        <label className="boldie">{t("billing.accepted_by")}</label>
                                                                    </div>
                                                                    <div className="col-8 col-md-8 col-lg-6 text-sm-left mtem-05">
                                                                        <label>{values?.accepted_by}</label>
                                                                    </div>
                                                                </div>
                                                                :null
                                                        }
                                                    </>
                                                    :null
                                            }
                                            <div className="row linea-formulario col-12 text-center">
                                                <div className="col-8 col-md-4 text-sm-left mtem-05">
                                                    <label className="boldie">{t("sass.integrador")}</label>
                                                </div>
                                                <div className="col-8 col-md-8 col-lg-6 text-sm-left mtem-05 mb-2">
                                                    {
                                                        !onEdit?
                                                            <label>{fullIntegrators?.find(m => m.integrador_id === values?.integrador_id)?.nombre}</label>
                                                            :
                                                            <Dropdown
                                                                value={values?.integrador_id}
                                                                onChange={(e) => {
                                                                    const dealer = fullIntegrators?.find(m => m.integrador_id === e.value);
                                                                    setFieldValue("tag_id",dealer?.tag_id);
                                                                    setFieldValue("integrador_id",dealer?.integrador_id);
                                                                    if(billingInfoFarm?.integrador_id && billingInfoFarm?.integrador_id !== e.value && !values.unlinkIntegrator){
                                                                        const prevDealer = fullIntegrators?.find(m => m.integrador_id === billingInfoFarm?.integrador_id);
                                                                        unlinkIntegrator(prevDealer);
                                                                    }
                                                                }}
                                                                options={integrators} optionLabel="nombre" optionValue="integrador_id"
                                                                optionGroupLabel="label" optionGroupChildren="integrators"
                                                                className="flex lgInputCstm w-100 p-0-ddpr" placeholder={t("sass.integrador")}
                                                                inputId="integrador_id" name="integrador_id"
                                                            />
                                                    }
                                                </div>
                                            </div>
                                            <div className="row linea-formulario col-12 text-center">
                                                <div className="col-8 col-md-4 text-sm-left mtem-05">
                                                    <label className="boldie">{t("billing.hub")}</label>
                                                </div>
                                                <div className="col-8 col-md-8 col-lg-6 text-sm-left mtem-05">
                                                    <label>{values?.hub}</label>
                                                </div>
                                            </div>

                                            <div className="row linea-formulario col-12 text-center">
                                                <div className="col-8 col-md-4 text-sm-left mtem-05">
                                                    <label className="boldie">{t("billing.priceListPage.title")}</label>
                                                </div>
                                                <div className="col-8 col-md-8 col-lg-6 text-sm-left mtem-05">
                                                    <label>{values?.list}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </Formik>
            <Formik innerRef={formikRefDatosFact}
                initialValues={{
                }}
                validate={(data) => {
                    const errors = {};
                    if(!data?.datos_fact?.nombre){
                        errors.datos_fact_nombre = "Required";
                    }
                    if(!data?.datos_fact?.direccion){
                        errors.datos_fact_direccion = "Required";
                    }
                    if(!data?.datos_fact?.ciudad){
                        errors.datos_fact_ciudad = "Required";
                    }
                    if(!data?.datos_fact?.tipo_pais_id){
                        errors.datos_fact_tipo_pais_id = "Required";
                    }
                    const requiredVat = countries?.find(c => c?.tipo_pais_id === data?.datos_fact?.tipo_pais_id)?.required_vat;
                    if(requiredVat && !data?.datos_fact?.vat_id){
                        errors.datos_fact_vat_id = "Required";
                    }
                    return errors;
                }}
                onSubmit={async (formData) => {
                    setIsLoading(true);
                    setIsLoading(true);
                    await RestAPI.put("apiAdminDropControl", "/billing/billingparams", {body: {"datos_fact":{...formData.datos_fact}, "type":"datosFact", "campo_id":dataSource?.campo_id}}).then(async (response) => {
                        setIsLoading(false);
                        toast.success(t("billing.billingparamsSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                        const index = billingInfoFarm?.datos_fact_list?.findIndex(d => d.datos_fact_id === response?.newDatosFact?.[0].datos_fact_id);
                        if (index === -1) {
                            setNewDatosFact(response?.newDatosFact?.[0]);
                        }
                        formikRef.current && formikRef.current.setFieldValue("datos_fact",response?.newDatosFact?.[0]);
                        setOnEditFact(false);
                    })
                        .catch((error) => {
                            if(error?.response?.data === "MISSING_FACT_DATA"){
                                toast.error(t("billing.errorMissingData"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                            }
                            else if(error?.response?.data === "MISSING_VAT"){
                                toast.error(t("billing.errorMissingVat"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                            }
                            else{
                                toast.error(t("billing.billingparamsError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                            }
                            setIsLoading(false);
                            console.log(error);
                        });
                }}
            >
                {({handleSubmit, values, setFieldValue, handleChange, errors}) => (
                    <div className='row'>
                        <div className="col-xl-12 col-lg-12 col-sm-12">
                            <DatosFact
                                farmInfo={billingInfoFarm} countries={countries} noEditable={!onEditFact}
                                values={values} setFieldValue={setFieldValue} header ownEditBtns
                                handleSubmit={handleSubmit} setEditable={setOnEditFact} formikRef={formikRefDatosFact} errors={errors}
                                originalValues={originalValues} setOriginalValues={setOriginalValues} newDatosFactList={newDatosFactList} setNewDatosFactList={setNewDatosFactList}
                                newDatosFact={newDatosFact} setNewDatosFact={setNewDatosFact} setBillingInfoFarm={setBillingInfoFarm} validate={validate} setValidate={setValidate}
                            />
                        </div>
                    </div>
                )}
            </Formik>
        </div>
        </>
    );
};

export default withName(BillingParams, "BillingParams");
